import { Component} from '@angular/core';
import { ModalController } from 'ionic-angular';
import * as debug from 'debug';
import * as _ from 'lodash';


@Component({
  selector: 'introduction-post-prompt',
  templateUrl: 'introduction-post-prompt.html',
})
export class IntroductionPostPromptComponent {
  log = debug('app:IntroductionPostPromptComponent');

  introPrompt:string = '';


  firstIntroQuestion = [
    {
        prompt:'Introduce yourself to the community!',
        icons:  '/assets/imgs/intro_post_icons/hand_wave_two_tone.svg',
        progressWidth: '14.3%',
        id:'experience',
        
    },
  ]

  constructor(public modalCtrl: ModalController) {}
    
    nextIntroQuestion(){
        const introModal = this.modalCtrl.create('IntroPostQuestionsPage')
        introModal.present();
    }  

}



// WEBPACK FOOTER //
// ./src/components/introduction-post-prompt/introduction-post-prompt.ts